import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { messageProvider } from '@/utils/MessageProvider'
import { ApiTaLi180 } from '~/endpoints/ApiTaLi180'

export interface StateLoginHistory {
  hasHistory: boolean | null
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}

/**
 * 初期状態の StateLoginHistory を返す
 * @returns 初期状態のオブジェクト
 */
export const getEmptyStateLoginHistory = (): StateLoginHistory => ({
  hasHistory: null,
  statusCode: 0,
  error: null,
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/LoginHistory',
})
export default class LoginHistory extends VuexModule {
  private state_: StateLoginHistory = getEmptyStateLoginHistory()

  get result(): StateLoginHistory {
    return this.state_
  }

  @Mutation
  updateLoginHistory(value: StateLoginHistory) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateLoginHistory'

  @Action
  clear() {
    this.context.commit(LoginHistory.MUTATION_NAME_UPDATE_STATE, getEmptyStateLoginHistory())
  }

  /**
   * ログイン履歴を確認・更新する
   * APIを呼び出し、履歴の有無をステートに保存する
   */
  @Action
  async checkLoginHistory() {
    logger.trace('in: checkLoginHistory')
    const api = new ApiTaLi180.Api()

    const result = await api.post<StateLoginHistory>(
      {},
      (data, status) => {
        return {
          hasHistory: data.hasHistory,
          statusCode: status,
          error: null,
        }
      },
      (data, status) => {
        return {
          hasHistory: getEmptyStateLoginHistory().hasHistory,
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateLoginHistory = getEmptyStateLoginHistory()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      if (commitdata.error === null) {
        commitdata.hasHistory = result.hasHistory
      }
    } else {
      const msgId = 'MSG-00-00023-E'
      commitdata.error = {
        messageId: msgId,
        message: messageProvider.get(msgId),
      }
    }
    this.context.commit(LoginHistory.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
